import * as React from 'react';
import classnames from 'classnames';
import { LimeWrapper } from '@grandvisionhq/lib-lime';
import { useSelector } from '@grandvisionhq/state';
import { useTransitionColor } from '../../../hooks/use-transition-color.js';
import { useRxConfiguratorSlots } from '../../../slots/context.js';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import { getSelectedFrame, getSelectedAddOn, getFrameImage } from '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import '@grandvisionhq/lib-lime/css';

const FrameImage = ({ className  })=>{
    var ref1;
    const transitionColor = useTransitionColor();
    const { Slots  } = useRxConfiguratorSlots();
    const frame = useSelector(getSelectedFrame);
    const selectedAddOn = useSelector(getSelectedAddOn);
    const frameImageUrl = useSelector((s)=>{
        var ref;
        return (ref = getFrameImage(s, {
            width: 592
        })) === null || ref === void 0 ? void 0 : ref.url;
    });
    const altText = `${frame === null || frame === void 0 ? void 0 : frame.brand} ${frame === null || frame === void 0 ? void 0 : frame.code}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('frame-image', className)
    }, frame && frameImageUrl && Slots.ProductImage ? /*#__PURE__*/ React.createElement(Slots.ProductImage, {
        className: "frame-image__product",
        imageUrl: frameImageUrl,
        altText: altText
    }, transitionColor && /*#__PURE__*/ React.createElement(LimeWrapper, {
        frameUPC: frame.sku,
        frameSrc: frameImageUrl,
        lensColor: transitionColor,
        transitionType: selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref1 = selectedAddOn.transitionType) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()
    })) : null);
};

export { FrameImage };
//# sourceMappingURL=FrameImage.js.map
